import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class HangTagOutline extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon width="22" height="22" viewBox="0 0 22 22">
                <g fill="none" fillRule="evenodd" transform="translate(-1 -1)">
                    <path d="M0 0h24v24H0z" />
                    <circle cx="16.5" cy="7.5" r="1.5" fill="#1FC8BF" fillRule="nonzero" />
                    <path
                        fill="#1FC8BF"
                        fillRule="nonzero"
                        d={`M10 22.8c-1.1 0-2.1-.4-2.8-1.2l-4.8-4.8C1.6 16 1.2 15 1.2
                            14c0-1.1.4-2.1 1.2-2.8l8.8-8.8c.9-.9 2.1-1.3 3.3-1.1l4.2.5c1.8.2 3.2 1.7 3.5 3.5l.5 4.2c.2 1.2-.3 2.4-1.1
                            3.3l-8.8 8.8c-.7.7-1.7 1.2-2.8 1.2zm4.1-19.6c-.5 0-1 .2-1.4.6l-8.8 8.8c-.4.4-.7.9-.7 1.4 0 .5.2 1 .6 1.4l4.8
                            4.8c.8.8 2.1.8 2.8 0l8.8-8.8c.4-.4.6-1 .6-1.7l-.5-4.2c-.1-.9-.8-1.6-1.7-1.7l-4.2-.5c-.2-.1-.2-.1-.3-.1z`}
                    />
                </g>
            </SvgIcon>
        );
    }
}
